import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { launchPadRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const LaunchpadMicroApp = () => import('@/pmd/pages/LaunchpadMicroApp.vue').then(m => m.default)

export const launchPadRoute: RouteConfig[] = [
  {
    path: 'launchpad',
    name: launchPadRouteNames.default,
    component: LaunchpadMicroApp,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.Launchpad, Modules.SmartList, Modules.ContactDetail] },
  },
]
